import { useEffect, useState } from "react";
import { delete_User, get_all_role } from "services/auth/permission";
import PropTypes from 'prop-types';
import { Field, Form, Formik } from "formik";
import BaseTextField from "general/custom-fields/BaseTextField";
import Swal from 'sweetalert2';
import { t } from 'i18next';
import * as Yup from 'yup';
import checkPermissionFunction from "Permission";
import { FUNCTION, PATH } from "pages/AuthorityRole/defineroles";
import Utils from "general/utils/Utils";

Modal_EditUser.propTypes = {
    onSubmit: PropTypes.func,
};

Modal_EditUser.defaultProps = {
    onSubmit: null,
}

function Modal_EditUser(props) {
    const { initialValues, onSubmit, onrefresh, dismiss } = props;
    const [selectedOption, setSelectedOption] = useState({});
    const [roles, set_Roles] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const roles = await get_all_role();
            set_Roles(roles.data.data);
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (initialValues.roleId && roles.length > 0) {
            setSelectedOption(roles.find(role => role?.roleId == initialValues?.roleId));
        }
    }, [initialValues, roles])


    const handleDelete = async () => {
        const username = initialValues.username;
        const result = await Swal.fire({
            title: t('Notification'),
            text: "Bạn có chắc chắn muốn xóa người dùng này không?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('Cancel'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        })

        if (result.value) {
            const res = await delete_User([username]);
            console.log(res);
            await Swal.fire({
                title: t('Notification'),
                text: res.data.message,
                icon: 'warning',
                // showCancelButton: true,
                confirmButtonText: t('Yes'),
                // cancelButtonText: t('Cancel'),
                customClass: {
                    confirmButton: 'btn btn-danger font-weight-bolder',
                    cancelButton: 'btn btn-light font-weight-bolder',
                }
            }).then((res) => {
                if (res.value) {
                    onrefresh();
                }
            })
        }
        dismiss();
    }

    const validationSchema = Yup.object().shape({
        // username: Yup.string().email(t('EmailNotValid')).required(t('EmailIsRequired')),
        password: Yup.string().trim().required(t('PasswordIsRequired')),
        username: Yup.string().trim().required(t('AccountIsRequired')),
    });

    return <Formik
        initialValues={initialValues}
        onSubmit={(values, actions) => { onSubmit({ ...values, password: Utils.isSHA256(values.password) == true ? values.password : Utils.sha256(values.password), roleId: selectedOption.roleId }, actions); dismiss() }}
        enableReinitialize={true}
        validationSchema={validationSchema}
    >
        {formikProps => {
            const { values, errors, touched, isSubmitting } = formikProps;

            return <Form>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"><b>Sửa người dùng</b></h5>
                        <button type="button" className="btn-close" onClick={() => { dismiss() }} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6">
                                <Field
                                    name="username"
                                    label={'Tên đăng nhập'}
                                    placeholder={`Tên đăng nhập...`}
                                    component={BaseTextField}
                                    asterisk='true'
                                    disabled={true}
                                // fieldMeta={{ error: "Bạn chưa nhập thông tin" }}
                                // text="Tên đăng nhập không được để trống"
                                />
                            </div>
                            <div className="col-md-6">
                                <Field
                                    name="email"
                                    label={'Email'}
                                    component={BaseTextField}
                                    placeholder={`Email...`}
                                // asterisk='true'
                                // disabled={true}
                                // fieldMeta={{ error: "Bạn chưa nhập thông tin" }}
                                // text="Email không được để trống"
                                />
                            </div>
                            <div className="col-md-6">
                                <Field
                                    name="fullname"
                                    label={'Họ tên'}
                                    component={BaseTextField}
                                    placeholder={`Họ tên...`}
                                // asterisk='true'
                                // fieldMeta={{ error: "Bạn chưa nhập thông tin" }}
                                // text="Họ tên không được để trống"
                                />
                            </div>
                            <div className="col-md-6">
                                <Field
                                    name="phone"
                                    label={'Số điện thoại'}
                                    placeholder={`Số điện thoại...`}
                                    component={BaseTextField}
                                // text="Số điện thoại phải bắt đầu bằng số 0 và có 10 chữ số"
                                />
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <label htmlFor="chooseRange" className="font-weight-bolder">Vai trò <b className="text-danger">(*)</b></label></div>
                                    <div className="KeenSelectOption">
                                        <div className="w-100">
                                            <div className="dropdown">
                                                <button type="button" id="chooseRange" data-bs-toggle="dropdown" aria-expanded="false"
                                                    className="w-100 cursor-pointer border shadow-none d-flex align-items-center justify-content-between dropdown-toggle btn">
                                                    {selectedOption?.name ?? "Chọn vai trò"}
                                                </button>
                                                <ul className="dropdown-menu w-100" aria-labelledby="chooseRange">
                                                    {
                                                        roles.map((option, index) => (
                                                            <span key={index} className={`dropdown-item border-bottom ${selectedOption?.name == option?.name ? "text-primary" : ""}`}
                                                                style={{ borderTop: "1px", display: "flex", justifyContent: "space-between" }}
                                                                onClick={() => setSelectedOption(option)}
                                                            >
                                                                <span>
                                                                    {option.name}
                                                                </span>
                                                                {
                                                                    selectedOption == option &&
                                                                    <div className="d-flex align-items-center justify-content-end">
                                                                        <i className="fa fa-check text-primary" style={{ fontSize: '10px' }}></i>
                                                                    </div>
                                                                }
                                                            </span>
                                                        ))
                                                    }
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <Field
                                    name="password"
                                    label={`Mật khẩu`}
                                    placeholder={`Nhập mât khẩu...`}
                                    component={BaseTextField}
                                    asterisk='true'
                                    type='password'
                                // disabled={true}
                                // fieldMeta={{ error: "Bạn chưa nhập thông tin" }}
                                // text="Mật khẩu phải phải lớn hơn 6 kí tự"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="w-100 d-flex row gap-3">
                            <button type="button" className="font-weight-bold flex-grow-1 col btn btn-secondary" onClick={() => dismiss()}>Hủy bỏ</button>
                            <button type="button" className="font-weight-bold flex-grow-1 col btn btn-danger"
                                // onClick={() => { handleDelete(); dismiss() }}
                                onClick={() => { checkPermissionFunction(PATH.UserManagement, FUNCTION.delete, () => handleDelete()) }}

                            >Xóa</button>
                            <button type="submit" className="font-weight-bold flex-grow-1 col btn btn-primary" >Cập nhật</button>
                        </div>
                    </div>
                </div>
            </Form>
        }}
    </Formik>
};

export default Modal_EditUser;
